import { Autocomplete, TextField } from '@mui/material';
import { PartnerCompanyEntity } from 'src/entities/PartnerCompanyEntity';

type Props = {
  partnerCompanyEntities: PartnerCompanyEntity[];
  value: string;
  id: number;
  update: (id: number, value: string, useLtl: boolean) => void;
  forceFocus?: boolean;
  label?: string;
};

function CarrierCompanySelector({
  partnerCompanyEntities,
  value,
  id,
  update,
  forceFocus = true,
  label = '',
}: Props) {
  return (
    <Autocomplete
      freeSolo
      fullWidth
      options={partnerCompanyEntities.map((it) => it.name)}
      value={value || ''}
      onChange={(_, newValue) => {
        const partnerCompany = partnerCompanyEntities.find((it) => it.name === newValue);
        const useLtl = partnerCompany?.category === '路線会社' || false;
        update(id, newValue, useLtl);
      }}
      onBlur={(event) => {
        const newValue = (event.target as HTMLInputElement).value;
        const partnerCompany = partnerCompanyEntities.find((it) => it.name === newValue);
        const useLtl = partnerCompany?.category === '路線会社' || false;
        update(id, newValue, useLtl);
      }}
      openOnFocus
      renderInput={(inputParams) => (
        <TextField
          {...inputParams}
          margin="dense"
          type="text"
          label={label}
          InputLabelProps={{ shrink: true }}
          fullWidth
          variant="standard"
          inputRef={(input: HTMLInputElement | null) => {
            if (!forceFocus) return;

            if (input) {
              input.focus();
            }
          }}
          sx={{ '& .MuiInputBase-root': { width: '100%' } }}
          onKeyDown={(event) => {
            const newValue = (event.target as HTMLInputElement).value;
            const partnerCompany = partnerCompanyEntities.find((it) => it.name === newValue);
            const useLtl = partnerCompany?.category === '路線会社' || false;
            if (event.key === 'Tab') {
              update(id, newValue, useLtl);
            }
          }}
        />
      )}
      sx={{
        width: '100%', // Autocomplete の幅を横いっぱいに広げる
      }}
    />
  );
}

export default CarrierCompanySelector;
